<template>
  <div v-if="show && suggestionData && suggestionData.gapToNextThreshold" class="suggestion-panel">
    <h4 class="suggestion-title">凑单建议</h4>
    <div class="suggestion-highlight">
      距下一档满减还差 <span class="gap-amount">{{ suggestionData.gapToNextThreshold }}</span> 元
      <span v-if="suggestionData.addedDiscount > 0" class="save-hint">
        （再凑满可多减 {{ suggestionData.addedDiscount }} 元）
      </span>
    </div>
    <table v-if="suggestionData.suggestions.length > 0" class="suggestion-table">
      <thead>
        <tr>
          <th>建议参与人</th>
          <th>建议凑单金额</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(s, i) in suggestionData.suggestions" :key="i">
          <td>{{ s.personName }}</td>
          <td>{{ s.suggestedAddAmount }} 元</td>
        </tr>
      </tbody>
    </table>
    <button @click="handleCopy" class="btn btn-copy-suggestion">复制凑单建议</button>
  </div>
</template>

<script>
export default {
  name: 'SuggestionPanel',
  props: {
    suggestionData: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCopy() {
      if (!this.suggestionData) return
      let text = `【凑单建议】\n距下一档满减还差 ${this.suggestionData.gapToNextThreshold} 元\n`
      if (this.suggestionData.addedDiscount > 0) {
        text += `凑满后可多减 ${this.suggestionData.addedDiscount} 元\n`
      }
      text += '\n建议凑单分配：\n'
      this.suggestionData.suggestions.forEach(s => {
        text += `  ${s.personName}：+${s.suggestedAddAmount} 元\n`
      })
      navigator.clipboard.writeText(text).then(() => {
        alert('凑单建议已复制到剪贴板')
      }).catch(() => {
        alert('复制失败，请手动复制')
      })
    }
  }
}
</script>

<style scoped>
.suggestion-panel {
  background: linear-gradient(135deg, #fff5f5 0%, #fffaf0 100%);
  border: 1px solid #fbd38d;
  border-radius: 8px;
  padding: 12px;
  margin-top: 15px;
}

.suggestion-title {
  font-size: 14px;
  font-weight: 700;
  color: #c05621;
  margin-bottom: 8px;
  text-align: center;
}

.suggestion-highlight {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 10px;
}

.gap-amount {
  font-size: 22px;
  font-weight: 700;
  color: #e53e3e;
}

.save-hint {
  display: block;
  font-size: 12px;
  color: #48bb78;
  margin-top: 4px;
}

.suggestion-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 10px;
}

.suggestion-table th {
  background: #fefcbf;
  padding: 6px 8px;
  text-align: center;
  font-weight: 600;
  color: #744210;
  border: 1px solid #f6e05e;
}

.suggestion-table td {
  padding: 5px 8px;
  text-align: center;
  border: 1px solid #fefcbf;
}

.btn-copy-suggestion {
  width: 100%;
  background: #ed8936;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-copy-suggestion:hover {
  background: #dd6b20;
  transform: translateY(-1px);
}

@media (max-width: 750px) {
  .gap-amount {
    font-size: 20px;
  }

  .suggestion-highlight {
    font-size: 14px;
  }
}
</style>
